export default __webpack_public_path__ + "static/media/voting---election-removebg-preview.8edd57e1.png";